import styled, { css } from 'styled-components';
import { px2rem, borderShape, backgroundShape, getColor } from '../../../stylesheets/tools';

export const StyledFilterTags = styled.div`
  display: flex;
  flex-wrap: wrap;

  .filterTags__tag {
    position: relative;
    margin-right: 10px;
    margin-bottom: 10px;
    padding: 5px 10px;
    transform: perspective(1px);
    ${backgroundShape()}
    
    ${props =>
      props.inverted &&
      css`
        ${borderShape('#fff')}
      `}

    ${props =>
      props.border &&
      css`
        ${borderShape()}
      `}
    &:last-of-type {
      margin-right: 0;
    }

    ${props =>
      props.alignRight &&
      css`
        margin-left: 10px;
        margin-right: 0;
      `}
  }
  
  .filterTags__tag--selected {
    ${props => backgroundShape(props.theme.globalTheme.primary)};
    color: ${getColor('white')};
  }

  p {
    display: inline-block;
    text-transform: uppercase;
    font-size: ${px2rem('14px')};
    position: relative;
    color: ${props => (props.border ? '#000' : '#fff')};

    [data-whatinput='mouse'] &,
    [data-whatinput='touch'] & {
      outline: 0;
    }

    @media print {
      display: none;
    }
  }
`;

export const StyledFilterTagsSkeleton = styled.div`
  display: flex;

  span {
    position: relative;
    display: block;
    width: ${px2rem('80px')};
    height: ${px2rem('28px')};
    margin-right: 10px;
    animation: opacityLoading 1.5s linear infinite alternate;
    background: #ececec;
    clip-path: polygon(10px 0, 100% 0, 100% 100%, 0 100%, 0 10px);

    &:last-of-type {
      margin-right: 0;
    }
  }
`;
